/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TeamsHealthcheckParams } from './teamsHealthcheckParams';

/**
 * Request model for Teams healthcheck job
 */
export interface RunTeamsHealthcheckJobRequest {
  type: 'teams_healthcheck';
  params: TeamsHealthcheckParams;
  allowOverlappingJobs?: boolean;
}
